import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { DsLoadingSpinner } from '@frontend/ui/loading-spinner';

import { CommonMessages } from '../client-config/common-messages.client-config';
import { Page } from '../client-config/page.client-config';
import { UtilsService } from '../utils/utils.service';
import { LoadingIndicatorService } from './loading-indicator.service';

/**
 * @stable
 */
@Component({
    imports: [DsLoadingSpinner],
    selector: 'vn-loading-indicator',
    templateUrl: 'loading-indicator.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingIndicatorComponent implements OnInit {
    content: SafeHtml;
    loadingIndicatorV2: boolean;

    readonly loadingIndicatorService = inject(LoadingIndicatorService);
    readonly commonMessages = inject(CommonMessages);
    private readonly page = inject(Page);
    private readonly sanitizer = inject(DomSanitizer);

    ngOnInit() {
        this.content = this.sanitizer.bypassSecurityTrustHtml(this.page.loadingIndicator.spinnerContent);
        this.loadingIndicatorV2 = this.page.htmlSourceTypeReplace
            ? UtilsService.indexableTypeContainsKey(this.page.htmlSourceTypeReplace, 'ds-loading-spinner')
            : false;
    }
}
